import React from 'react';
import Text from '@ingka/text';
import { useTranslation } from 'react-i18next';
import PageContent from '../components/PageContent';
import PageTitle from '../components/PageTitle';
import { StyledWrapper } from '../components/PageLayout';

const FollowUpConfirmPage: React.FC = () => {
  const { t } = useTranslation();

  return (
    <>
      <PageTitle title={t('pages.followup.confirm.pageTitle')} />
      <StyledWrapper $withStickyFooter={false}>
        <PageContent>
          <Text tagName="h1" textStyle="Heading.L">
            {t('pages.followup.confirm.title')}
          </Text>
          {/* TODO: Submit the follow-up booking linked to the original appointment. */}
        </PageContent>
      </StyledWrapper>
    </>
  );
};

export default FollowUpConfirmPage;
